import { render, staticRenderFns } from "./MainzHowTo.vue?vue&type=template&id=b78f815e&"
import script from "./MainzHowTo.vue?vue&type=script&lang=js&"
export * from "./MainzHowTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports